<template>
  <div id="app">
    <h1>Current Damage in Ukraine</h1>
    <div class="map__contaienr" :class="{ 'blur-map': mapClicked }">
      <Hanrei />
      <mainMap @clicked="popup" />
    </div>
    <Details v-if="mapClicked" @closepop="closed" />
  </div>
</template>

<script>
import Hanrei from './components/Hanrei.vue'
import mainMap from './components/mainMap.vue'
import Details from './components/details.vue'

export default {
  name: 'app',
  components: {
    mainMap,
    Hanrei,
    Details
  },
  data() {
    return {
      mapClicked: false
    }
  },
  methods: {
    popup() {
      this.mapClicked = !this.mapClicked
    },
    closed() {
      // console.log("aa")
      this.mapClicked = false
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 40px;
}

.blur-map {
  opacity: .5;
}

@media screen and (max-width: 750px) {
  h1 {
    font-size: 24px;
  }
}
</style>
